import { useMemo } from 'react';

import { selectableSkillsetPeriods } from './skillsetWindow';

import { useGetEmployeeEvaluationPeriods } from '@/api/performance-profile';

/**
 * The periods the profile may filter an employee's competencies and score by.
 *
 * The one place that rule is decided: the picker lists these, and the page names the picked period
 * under the score from these very ones. Read from two different rules, the score would name a
 * period its own menu does not offer.
 */
export const useSkillsetEvaluationPeriods = (employeeId?: string) => {
    const { data, isLoading } = useGetEmployeeEvaluationPeriods(employeeId);

    return {
        periods: useMemo(() => selectableSkillsetPeriods(data), [data]),
        arePeriodsLoading: isLoading,
    };
};
